import { Backdrop, CircularProgress, Grid, Slide, Stack } from '@mui/material';
import { Navigate, Outlet, useLocation } from 'react-router';

import { BASE } from 'common/src/routes/BaseRoutes';

import useAuth from '../auth/useAuth';
import { LayoutContext } from './LayoutPreference/layoutTypes';
import { useLayoutPreference } from './LayoutPreference/useLayoutPreference';
import Menu from './menu/Menu';

const AuthenticatedLayout = () => {
  const { isAuthenticated, isReadyForAuthorization, isPasswordExpired } =
    useAuth();
  const { pathname, search } = useLocation();
  const { isTabletMenuOpen, setIsTabletMenuOpen } = useLayoutPreference();

  if (!isAuthenticated()) {
    return (
      <Navigate
        to={BASE.AUTH.LOGIN}
        state={{ from: { pathname, search } }}
        replace
      />
    );
  } else if (isPasswordExpired()) {
    return <Navigate to={BASE.AUTH.CHANGE_EXPIRED_PASSWORD} replace />;
  }

  if (!isReadyForAuthorization()) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }

  return (
    <Grid container columns={16} sx={{ minHeight: '100vh' }}>
      <Slide direction="right" in mountOnEnter unmountOnExit>
        <Grid
          size="auto"
          sx={{
            height: '100vh',
            position: 'sticky',
            top: 0,
            alignSelf: 'flex-start',
            zIndex: (theme) => theme.zIndex.appBar + 1,
          }}
        >
          <Menu
            open={isTabletMenuOpen}
            menuItemClick={() => setIsTabletMenuOpen(false)}
          />
        </Grid>
      </Slide>
      <Grid
        sx={{
          margin: 0,
          position: 'relative',
          zIndex: 1,
        }}
        size="grow"
      >
        <Stack sx={{ height: '100%' }}>
          <Outlet
            context={
              {
                setOpenMobile: setIsTabletMenuOpen,
              } as LayoutContext
            }
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default AuthenticatedLayout;
